// Keys existing in tableData that will not be displayed as a column
export const excludedTableDataKeys: string[] = ['navigationID', 'userId'];

export const MAX_TD_LABEL_VALUE_LENGTH_TABLET = 10;
export const MAX_TD_LABEL_VALUE_LENGTH = 15;

// How far below the viewport the infinite scroll sentinel starts pulling the
// next page, so rows are already in place by the time the user reaches them.
export const LOAD_MORE_ROOT_MARGIN = '300px';
